let React = require('react');
const FormatMessage = require('react-globalize').FormatMessage;

let SectionSubpoemaLaw_en = React.createClass({

  render : function () {
    return (
      <section id="section4" className="content-section  about-section sectionPage">
        <div className='row'>
          <div className="col-lg-8 col-lg-offset-2 col-sm-10 col-sm-offset-1">
            <div className="title-v1">
              <div className="row">
                  <div className="col-sm-12   col-xs-12">
                      <h1 className="text-center">BARRI’S PROCEDURES FOR LAW ENFORCEMENT REQUESTS</h1>
                      <hr className="small text-center"/>
                      <p>UNITED STATES LAW ENFORCEMENT AGENCIES SERVING SUBPOENAS, COURT ORDERS, AND ORDERS REQUIRED ARE TO BE SERVED BY BARRI MONEY SERVICES, LLC</p>
                  </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <p>Barri's Legal Compliance department will respond to law enforcement requests such as subpoenas, search warrants, court orders, requests to testify, or other forms of compliance requests in accordance with applicable law.</p>
                  <p>In order to ensure a prompt response, we ask law enforcement to comply with the following requirements when submitting a request:</p>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <ol>
                    <li>Email is the preferred way to receive a request: Email us at <a href='mailto:subpoenas@barri.com'>subpoenas@barri.com</a></li>
                    <li>You may also send your request by mail, our address is 10777 Westheimer Road, Suite 1040, Houston,TX 77042, USA.</li>
                    <li>Please include an email address on all requests, as Barri's policy is to provide records and information only via secure encrypted email.</li>
                  </ol>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <p>
                    <b>Please note:</b>  
                  </p>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-xs-12 col-md-12 col-lg-12'>
                  <ul>
                    <li>Our privacy notice sets out how Barri handles personal data and is available at <a href='/bfgPrivacySt' target="_blank">https://www.barri.com/bfgPrivacySt</a></li>
                    <li>The default time zone of transactional money transfer data is provided in Central US Time (CST).</li>
                    <li>All subpoenas must be accompanied by the full name, title, mailing address, email address, phone number, and facsimile number of the person and/or entity issuing the subpoena and the full name, title, mailing address, email address, phone number and facsimile number of the person to whom documents should be sent. Without this information, Barri is unable to process subpoenas.</li>
                    <li><b>Barri</b> does not maintain video surveillance records of its Agent locations in the ordinary course of business. </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

})

export default SectionSubpoemaLaw_en;


// WEBPACK FOOTER //
// ./js/subpoena/subpoena_en.js